import { useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/layouts/PublicLayout";
import { api } from "@/lib/api";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch { /* silently fail to prevent enumeration */ setSent(true); }
    setLoading(false);
  };

  return (
    <PublicLayout>
      <section className="mx-auto max-w-md px-6 py-16">
        <div className="rounded-3xl border border-wine-100 bg-white p-8 shadow-sm">
          {!sent ? (
            <>
              <div className="grid h-12 w-12 place-items-center rounded-2xl bg-wine-100"><Mail className="h-6 w-6 text-wine-600" /></div>
              <h1 className="mt-4 font-serif text-3xl text-navy">{t("comp_forgotpassword_90")}</h1>
              <p className="mt-2 text-sm text-neutral-600">{t("comp_forgotpassword_91")}</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                       placeholder="vous@exemple.com"
                       className="w-full rounded-xl border border-neutral-200 px-4 py-2.5 text-sm focus:border-wine-400 focus:outline-none"
                       data-testid="forgot-email" />
                <button type="submit" disabled={loading}
                        className="w-full rounded-full bg-wine-500 py-2.5 text-sm font-bold text-white hover:bg-wine-600 disabled:opacity-60"
                        data-testid="forgot-submit">
                  {loading ? "Envoi…" : "Envoyer le lien de réinitialisation"}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center" data-testid="forgot-sent">
              <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
              <h1 className="mt-4 font-serif text-3xl text-navy">{t("comp_forgotpassword_92")}</h1>
              <p className="mt-3 text-sm text-neutral-600">
                Si un compte existe avec l&apos;adresse <strong>{email}</strong>, un lien de réinitialisation vient d&apos;être envoyé. Pensez à vérifier vos spams.
              </p>
            </div>
          )}
          <div className="mt-6 text-center">
            <Link to="/login" className="inline-flex items-center gap-1.5 text-xs font-semibold text-wine-700 hover:underline" data-testid="back-to-login">
              <ArrowLeft className="h-3.5 w-3.5" /> Retour à la connexion
            </Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
